import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import Card from "@material-ui/core/Card"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardContent from "@material-ui/core/CardContent"
import Box from "@material-ui/core/Box"
import CardMedia from "@material-ui/core/CardMedia"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import truncate from "lodash/truncate"

const useStyles = makeStyles((theme) => ({
  recipePreviewCard: {
    height: "100%",
    border: "1px solid #ecebea",
    boxShadow: "1px 3px 2px rgba(0, 0, 0, 0.05)",
    transition: "all 0.4s ease 0s",
    "&:hover": {
      transform: "translateY(-5px) scale3d(1.01, 1.01, 1.01)",
    },
  },
  recipePreviewHeading: {
    color: theme.palette.primary.main,
    marginTop: 0,
    marginBottom: 0,
    fontSize: "1.15rem",
  },
}))

const RecipePreview = ({
  recipe,
  showAbstract,
  className,
  path,
  eagerLoad,
}) => {
  const classes = useStyles()
  const link = `/${path}/${recipe.slug}/`

  return (
    <Card className={[classes.recipePreviewCard, className].join(" ")}>
      <CardActionArea href={link}>
        {recipe.thumbnailImage && (
          <CardMedia>
            <GatsbyImage
              alt={recipe.thumbnailImage.title}
              image={recipe.thumbnailImage.gatsbyImageData}
              loading={eagerLoad ? "eager" : "lazy"}
            />
          </CardMedia>
        )}

        <CardContent>
          <Typography variant="h3" className={classes.recipePreviewHeading}>
            {recipe.title}
          </Typography>

          <Typography variant="caption" gutterBottom>
            {recipe.createdAt}
          </Typography>

          {showAbstract && recipe.abstract && (
            <Box mt={2}>
              <Typography variant="body1">
                {truncate(recipe.abstract.abstract, {
                  length: 160,
                  separator: /,? +/,
                })}
              </Typography>
            </Box>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default RecipePreview

RecipePreview.defaultProps = {
  showAbstract: true,
  path: "recipe",
  eagerLoad: false,
}
